import {
  TaskSubgroup,
  WebSocketAction,
  WebSocketEntityType,
} from '@this+that/models';
import log from 'loglevel';

import { resolveSyncAction, SyncAction } from './taskSyncActions';
import { useEntitySync } from './useEntitySync';
import { useFetchTaskSubgroups } from '../../../hooks/TaskSubgroup/useFetchTaskSubgroups';
import { useInboxEntriesStore } from '../../../store';

export function useTaskSubgroupsSync() {
  const createTaskSubgroup = useInboxEntriesStore(
    (s) => s.taskManager.activeTaskGroup.createTaskSubgroup,
  );
  const updateTaskSubgroup = useInboxEntriesStore(
    (s) => s.taskManager.activeTaskGroup.updateTaskSubgroup,
  );
  const removeTaskSubgroup = useInboxEntriesStore(
    (s) => s.taskManager.activeTaskGroup.removeTaskSubgroup,
  );
  const { handleFetchTaskSubgroups } = useFetchTaskSubgroups();

  const apply = (event: WebSocketAction, item: TaskSubgroup) => {
    const active = useInboxEntriesStore.getState().taskManager.activeTaskGroup;
    const existing = active.taskSubgroups.find((sg) => sg.id === item.id);
    const belongs = item.taskGroupId === active.taskGroupId;
    const syncAction = resolveSyncAction(event, {
      exists: !!existing,
      belongs,
    });
    switch (syncAction) {
      case SyncAction.CREATE:
        createTaskSubgroup(item);
        break;
      case SyncAction.UPDATE:
        updateTaskSubgroup(item);
        break;
      case SyncAction.REMOVE:
        removeTaskSubgroup(item.id);
        break;
      default:
        break;
    }
  };

  useEntitySync<TaskSubgroup>(WebSocketEntityType.TaskSubgroup, {
    onInsert: (item) => apply(WebSocketAction.INSERT, item),
    onModify: (item) => apply(WebSocketAction.MODIFY, item),
    onRemove: (item) => apply(WebSocketAction.REMOVE, item),
    onReconnect: async () => {
      const { taskGroupId } =
        useInboxEntriesStore.getState().taskManager.activeTaskGroup;
      if (!taskGroupId) {
        return;
      }
      log.info(
        '[TaskSubgroupsSync] Reconnected after long pause, refetching subgroups',
      );
      try {
        await handleFetchTaskSubgroups(taskGroupId);
      } catch (error) {
        log.error(
          '[TaskSubgroupsSync] Failed to refetch task subgroups:',
          error,
        );
      }
    },
  });
}
